<template>
  <div class="form">

    <form novalidate class="md-layout" @submit.prevent="validateForm">

      <div class="form-material md-layout md-gutter">

        <div class="form-material-left md-layout-item">

          <md-field :class="getValidationClass('name')">
            <label for="name">{{ $t('form.name') }}</label>
            <md-input name="name" v-model="form.name" @input="sendData('name')" tabindex="1" required></md-input>
            <span class="md-error" v-if="!$v.form.name.required">{{ $t('form.name_required') }}</span>
          </md-field>

          <md-field :class="getValidationClass('job')">
            <label for="job">{{ $t('form.job') }}</label>
            <md-input name="job" v-model="form.job" @input="sendData('job')" tabindex="3" required></md-input>
            <span class="md-error" v-if="!$v.form.job.required">{{ $t('form.job_required') }}</span>
          </md-field>

          <md-field >
            <label for="pslogo">{{ $t('form.pslogo') }}</label>
            <md-select v-model="pslogo" name="pslogo" id="pslogo" @md-selected="this.sendPSLogo"  tabindex="5" >
              <md-option v-for="(item, key) in pslogos"
                :key="key"
                :value="key">{{ $t(`form.pslogoList.${key}`) }}
              </md-option>
            </md-select>
          </md-field>

          <md-field class="accolades-list">
            <label for="accolades">{{ $t('form.accolades') }}</label>
            <md-select :disabled="!office" v-model="accolade" name="accolades" id="accolades" @md-selected="this.sendAccolade" multiple md-dense tabindex="7">
              <md-option
                v-for="(item, key) in officeAccolades"
                :disabled="accolade.length >= 3 && accolade.indexOf(key) < 0"
                :key="key"
                :value="key">
                {{ $t(`form.accoladesList.${key}`) }}
              </md-option>
            </md-select>
          </md-field>


           <tel-input
            :label="$t('form.mobile')"
            :disabled="!office"
            name="mobile"
            tabindex="0"
            :default-iso="officeIsoCode"
            :default-value="mobile"
            @update:phone="phoneUpdated('mobile', 'formattedMobile', $event)">
          </tel-input>



          <div class="form-space"></div>

        </div>

        <div class="form-material-right md-layout-item">

          <md-field :class="getValidationClass('lastname')">
            <label for="lastname">{{ $t('form.lastname') }}</label>
            <md-input name="lastname" v-model="form.lastname" @input="sendData('lastname')" tabindex="2" required></md-input>
            <span class="md-error" v-if="!$v.form.lastname.required">{{ $t('form.lastname_required') }}</span>
          </md-field>


          <md-autocomplete name="pronouns" v-model="form.pronouns" :md-options="$t('form.pronounsList')" @input="sendData('pronouns')" tabindex="4">
            <ESPopin
                :show-dialog="true"
                :title="$t('form.pronounsPopin.title')"
                :text="$t('form.pronounsPopin.text')"
              />
            <label>
              {{ $t('form.pronouns') }}
              </label>
          </md-autocomplete>


             <md-field :class="['office-list', getValidationClass('office')]">
            <label for="office">{{ $t('form.office') }}</label>
            <md-select v-model="office" name="office" id="office" @md-selected="this.sendOffice" tabindex="6" required>
              <md-option v-for="(item, key) in offices"
                :key="key"
                :value="key">
                {{item.location}}
              </md-option>
            </md-select>
            <span class="md-error" v-if="!$v.office.required">{{ $t('form.office_required') }}</span>
          </md-field>


        <tel-input
            :label="$t('form.phone')"
            :disabled="!office"
            name="phone"
            :default-iso="officeIsoCode"
            :default-value="phone"
            @update:phone="phoneUpdated('phone', 'formattedPhone', $event)">
          </tel-input>


          <div class="form-space"></div>

        </div>

      </div>
	 


      <div class="mentions md-layout-item md-size-100">{{ $t('form.mentions') }}</div>
  </form>

  <button type="button" class="buttonSign" v-on:click="integrate">
      <div class="front">{{ $t("buttonIntegrate") }}</div>
  </button>

  </div>
</template>

<script>
import 'vue-material/dist/vue-material.min.css';
import ESPopin from './Popin.vue';
import TelInput from './TelInput/TelInput.vue';
import { validationMixin } from 'vuelidate';
import {
  required,
  minLength,
} from 'vuelidate/lib/validators';

import EventBus from '../eventBus';
import Utils from '../utils';
import offices from '../labels/offices';
import accolades from '../labels/accolades';
import pslogos from '../labels/pslogolist';

export default {
  name: 'ESForm',
  mixins: [validationMixin],
  data: function data() {
    return {
      form: {
        name: '',
        lastname: '',
        job: '',
        pronouns: '',
      },
	  donate: null,
      office: '',
      offices: offices,
      accolade: [],
      accolades: accolades,
      pslogo:'PS_Brand',
      pslogos:pslogos,
      mobile: '',
      formattedMobile: '',
      phone: '',
      formattedPhone: ''
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1)
      },
      job: {
        required,
        minLength: minLength(1)
      },
      lastname: {
        required,
        minLength: minLength(1)
      }
    },
    office: {
      required,
    }
  },
  components: {
    ESPopin,
    TelInput,
  },
  computed: {
    officeIsoCode: function() {
      if (offices[this.office] && offices[this.office].iso) {
        return offices[this.office].iso.toUpperCase();
      }
      return '';
    },
    officeAccolades() {
      if(this.office && (this.offices[this.office].accolades || []).length > 0) {
        const filteredAccolades = {};
        for (const key in this.accolades) {
          if(this.offices[this.office].accolades.includes(key)) {
            filteredAccolades[key] = this.accolades[key];
          }
        }
        return filteredAccolades;
      }
      return {};
    }
  },
  watch: {
    office: function(event) {
      EventBus.$emit('changeOffice', event);
    },
    pslogo: function(event) {
      EventBus.$emit('changePSlogo', event);
    },
    accolade: function(event) {
      EventBus.$emit('changeAccolade', event);
    },
    animated: function(event) {
      EventBus.$emit('changeAnimated', event);
    }
  },
  mounted: function () {
    EventBus.$on('validateForm', this.validateForm);
    EventBus.$on('changeIcon', this.onchangeIcon);
    EventBus.$on('changeIcon', this.onchangeIcon);
    EventBus.$on('changeLanguage', this.changeLanguage);

    const select = document.querySelector('.md-select input');
    select.style.paddingLeft = '15px';
    select.style.fontSize = '0.875rem';

    if (process.env.NODE_ENV === 'development') this.populateFrom();
  },
  methods: {
    integrate: function() {
      EventBus.$emit('validateForm');
      Utils.generateTag('navigation-step1', 'click');
    },
    changeLanguage: function() {
      this.$nextTick(function() {
        this.accolade = [];
      });
    },
    phoneUpdated: function(name, formatted, payload) {
      this[name] = payload.tel;
      this.sendData(name);

      this[formatted] = payload.intl;
      this.sendData(formatted);
    },
    sendData: function(name) {
      this.saveForm();
      EventBus.$emit('changeInput', this[name] || this.form[name], name);
    },
    sendOffice: function() {
      this.$nextTick(function() {
        this.sendData('office')
      });
    },
    sendPSLogo: function() {
      this.$nextTick(function() {
        this.sendData('pslogo')
      });
    },
    sendAccolade: function() {
      this.$nextTick(function() {
        this.sendData('accolade')
      });
    },
    validateForm () {
      this.$v.$touch();
      this.saveForm();
      if (!this.$v.$invalid) {
        EventBus.$emit('formValidated');
      }
    },
    onchangeIcon: function(obj) {
      this.icons[obj.id] = obj.name.replace('_', '-');
    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName] || this.$v[fieldName] || this.$v.icons[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clickColor (index) {
      if (index !== this.colors) {
        this.colors = index;
        EventBus.$emit('changeColors', index - 1);
      }
    },
    clearForm () {
      this.$v.$reset()
      this.form.name = null;
      this.form.lastname = null;
      this.form.job = null;
	  this.form.donate = null;
    },
    populateFrom () {
      var storageData = Utils.formStorage('fetch');
      //console.log('storageData', storageData);
      this.form = {
        name: storageData.name || '',
        lastname: storageData.lastname || '',
        job: storageData.job || '',
        pronouns: storageData.pronouns || '',
      };
	  this.donate = storageData.donate || '';
      this.office = storageData.office || this.office;
      this.mobile = storageData.mobile || '';
      this.phone = storageData.phone || '';
    },
    saveForm () {
      var formData = Object.assign({office: this.office, mobile: this.mobile, phone: this.phone, donate: 'on'}, this.form);
      Utils.formStorage('save', formData);
    },
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Form.vue